import PlanRepaymentReport from "./planRepaymentReport";
import { TabPane, Tabs } from "@douyinfe/semi-ui";
import { IconIdCard, IconMoneyExchangeStroked } from "@douyinfe/semi-icons";

export default function PlanRepaymentReportAgentAndCustomer() {
  return (
    <Tabs type="line" style={{ margin: 10 }}>
      <TabPane
        tab={
          <span>
            <IconMoneyExchangeStroked />
            月待还款汇总(代还)
          </span>
        }
        itemKey="1"
      >
        <PlanRepaymentReport
          name="月待还款汇总(代还)"
          entityKey="mortgageLoanReport/agent"
          reportType="PlanRepaymentReportAgent"
        />
      </TabPane>

      <TabPane
        tab={
          <span>
            <IconIdCard />
            月待还款汇总(自还)
          </span>
        }
        itemKey="2"
      >
        <PlanRepaymentReport
          name="月待还款汇总(自还)"
          entityKey="mortgageLoanReport/customer"
          reportType="PlanRepaymentReportCustomer"
        />
        ;
      </TabPane>
    </Tabs>
  );
}
